import { DateRule, LengthRule, RangeRule, RegexRule, ValidateValueConfig } from '../types';
import { confirmRegex } from '../constants';

import getDateTime from './getDateTime';

export const isFieldRequired = (config: ValidateValueConfig) => {
	const isInRequired = (config.values.requiredValues as string[] | undefined)?.includes(config.key);
	return isInRequired ?? config.rule.required;
}

export const isFieldFocused = (config: ValidateValueConfig) => {
	const ref = config.refs.current[config.key];
	return document.activeElement === ref;
}

export const isFileFromServer = (config: ValidateValueConfig) => {
	const isRequired = isFieldRequired(config);
	return config.values[`${config.key}Path`] && isRequired && !config.value;
}

export const isFile = (config: ValidateValueConfig) => {
	const isRequired = isFieldRequired(config);
	return !(isRequired && !config.value);
}

export const isDateBefore = (config: ValidateValueConfig) => {
	const rule = config.rule as DateRule;
	return !(config.value && (rule.dateType === 'date' || !rule.dateType) && (config.value as Date) > rule.before!);
}

export const isDateAfter = (config: ValidateValueConfig) => {
	const rule = config.rule as DateRule;
	return !(config.value && (rule.dateType === 'date' || !rule.dateType) && (config.value as Date) < rule.after!);
}

export const isTimeBefore = (config: ValidateValueConfig) => {
	const rule = config.rule as DateRule;
	return !(config.value && getDateTime(rule.dateType === 'timeRange' ? (config.value as [Date, Date])[1] : config.value) > getDateTime(rule.before!));
}

export const isTimeAfter = (config: ValidateValueConfig) => {
	const rule = config.rule as DateRule;
	return !(config.value && getDateTime(rule.dateType === 'timeRange' ? (config.value as [Date, Date])[0] : config.value) < getDateTime(rule.after!));
}

export const isStringGreaterThan = (config: ValidateValueConfig) => {
	const rule = config.rule as RangeRule<any>;
	return !(config.value && typeof config.value === 'string' && (config.value?.trim()?.length ?? 0) < (rule.greaterThan ?? -1));
}

export const isStringSmallerThan = (config: ValidateValueConfig) => {
	const rule = config.rule as RangeRule<any>;
	return !(config.value && typeof config.value === 'string' && (config.value?.trim()?.length ?? 0) > (rule.smallerThan ?? 3.154e+7));
}

export const isStringLength = (config: ValidateValueConfig) => {
	const rule = config.rule as LengthRule<any>;
	return !(!config.value && (config.value?.length ?? 0) !== rule?.length);
}

export const isRequiredValue = (config: ValidateValueConfig) => {
	const isRequired = isFieldRequired(config);
	return !(isRequired && !config.value);
}

export const isMatchActiveRegex = (config: ValidateValueConfig) => {
	const rule = config.rule as RegexRule<any>;
	return !((config.value?.length ?? 0) > 0 && !rule.activeRegex!.test(config.value));
}

export const isMatchRegexClassValidator = (config: ValidateValueConfig) => {
	const rule = config.rule as RegexRule<any>;
	return !(
		config.value && (
			(
				rule.regex && !rule.regex.test(config.value)
			) || (
				rule.classValidator && !rule.classValidator(config.value)
			)
		)
	);
}

export const isConfirmValid = (config: ValidateValueConfig) => {
	return !(config.key.match(confirmRegex) && config.values[config.key.match(confirmRegex)![0].toLowerCase().substring(7, config.key.match(confirmRegex)![0].toLowerCase()?.length)] !== config.value);
}